/** Shared contact details — footer, contact page, WhatsApp float */
export const whatsappNumbers = [
  {
    id: 'india',
    label: 'India',
    display: '+91 8500181606',
    href: 'https://wa.me/918500181606?text=Hi%20Rhutech%20Solutions%2C%20I%20need%20a%20quote%20for%20my%20project.',
    flag: '🇮🇳',
  },
  {
    id: 'uk',
    label: 'United Kingdom',
    display: '+44 7990 055735',
    href: 'https://wa.me/447990055735?text=Hi%20Rhutech%20Solutions%2C%20I%20need%20a%20quote%20for%20my%20project.',
    flag: '🇬🇧',
  },
];

export const offices = [
  {
    id: 'india',
    title: 'India Office',
    lines: [
      '74-28-3, Ground floor, Bhavani Shankar Rd',
      'Chowdhary Pet, Ayyappa Nagar',
      'Vijayawada, Andhra Pradesh 520007',
    ],
    phone: '+91 8500181606',
    phoneHref: 'tel:+918500181606',
  },
  {
    id: 'uk',
    title: 'UK Office',
    lines: ['Norwich, NR3', 'United Kingdom'],
    phone: '+44 7990 055735',
    phoneHref: 'tel:+447990055735',
  },
];

export const email = 'info@rhutechsolutions.com';
